import { Prisma } from '@prisma/client';
import { SolutionInclude } from '../includes/Solution';
var IncludeSolution = Prisma.validator()({
    include: SolutionInclude,
});
export var Maturity;
(function (Maturity) {
    Maturity["SEED"] = "SEED";
    Maturity["PROTOTYPE"] = "PROTOTYPE";
    Maturity["INITIAL_MARKET"] = "INITIAL_MARKET";
    Maturity["LARGE_MARKET"] = "LARGE_MARKET";
    Maturity["SOLUTION_AT_SCALE"] = "SOLUTION_AT_SCALE";
})(Maturity || (Maturity = {}));
//# sourceMappingURL=Solution.js.map